import { Mediator, app, ojs, payload } from "modular-openscriptjs";
import { approved, inform, processStart, processEnd, eParse } from "../helpers";
import { STRINGS, routes, api } from "../declarations";

const broker = app("broker");
const $e = app("$e");

export default class PaymentRequest extends Mediator {
	$$paymentRequest = {
		stored: (ed, event) => {},

		needs: {
			creation: (ed, event) => {
				let { message } = eParse(ed);

				this.broadcast(
					$e.paymentRequest.needs.requestForm,
					payload({ ...message.getAll() })
				);
			},

			storage: (ed, event) => {
				this.storeRequest(ed, event);
			},

			deletion: (ed, event) => {
				this.deleteRequest(ed, event);
			},
		},
	};

	// shouldRegister() {
	// 	return window.adminFilesLoaded == true;
	// }

	async storeRequest(ed, event) {
		let data = eParse(ed);

		processStart({ title: "Making request" });

		let orderId = data.message.get("order_id");

		let res = await api.post(
			`riders/${routes.paymentRequests}/orders/${orderId}/create`,
			data.message.getAll()
		);

		if (!res) {
			processEnd();
			return this.send(
				$e.paymentRequest.has.storageError,
				payload(data.message.getAll(), data.meta.getAll())
			);
		}

		inform(`Request Made successfully`, STRINGS.SUCCESS);
		processEnd();

		return this.send(
			$e.paymentRequest.stored,
			payload(data.message.getAll(), data.meta.getAll())
		);
	}

	async deleteRequest(ed, event) {
		let data = eParse(ed);
		if (!approved(event, ed, "You want to cancel/reverse this request"))
			return;

		processStart({ title: "Cancelling Payment Request" });
		let res = null;
		if ("refund" == data.message.get("type")) {
			res = await api.put(
				`riders/${routes.paymentRequests}/${data.message.get(
					"requestId"
				)}/refund`
			);
		} else {
			res = await api.delete(
				`riders/${routes.paymentRequests}/${data.message.get(
					"requestId"
				)}/delete`
			);
		}
		processEnd();

		if (!res) {
			return this.send($e.paymentRequest.has.deletionError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);
		return this.send($e.paymentRequest.deleted, ed);
	}
}

ojs(PaymentRequest);
